export default __webpack_public_path__ + "static/media/naturebible2.ac5d42f7.jpg";